import styled from '@emotion/styled';
import css from '@emotion/css';
import { device } from './device';

interface IStyledContainer {
  theme: { [key: string]: any };
  layout?: string;
  usertype?: string;
}

export const StyledContainer = styled.section<IStyledContainer>`
    width : ${(props: IStyledContainer) => props.theme.containerLayout.width};
    max-width : ${(props: IStyledContainer) => props.theme.containerLayout.maxWidth};
    margin: ${(props: IStyledContainer) => props.theme.containerLayout.margin};
    ${(props: IStyledContainer) => props.layout == "fluid" && css`
      width : ${props.theme.containerLayout.fluidWidth};
    `}

    @media screen and ${device.mobile},
    screen and (orientation: landscape) and (max-width: 1000px) {
      width : ${(props: IStyledContainer) => props.theme.containerLayout.mobileWidth};
    }

    ${(props: IStyledContainer) => props.usertype == "nonprime" && css`
      width: 636px;
      margin: 0 auto;
      text-align: left;
  @media screen and (min-width: 1000px) and (max-width: 1240px) { 
        margin: 0 325px 0 auto;
      }
      @media screen and ${device.mobile},
    screen and (orientation: landscape) and (max-width: 1000px) {
        padding: 0px;
      }
    `}

    ${(props: IStyledContainer) => props.layout == "faq" && css`
      position: relative;
      z-index: 0;
      padding: 0 16px;
      max-width: 1280px;
      width: 100%;
      @media screen and ${device.mobile},
    screen and (orientation: landscape) and (max-width: 1000px) {
      background: #fff;
      padding: 0 0 32px;
      z-index:1;
      transform: translate3d(0, 0, 0);
      }
    `}

    ${(props: IStyledContainer) => props.layout == "blockercontainer" && css`
    background: #fff;
    @media screen and ${device.mobile},
    screen and (orientation: landscape) and (max-width: 1000px) {
      position:relative;
      padding:32px 0 0 0;
      z-index:2;
      background: #fff;
      border-bottom:1px solid #fff;
    }
       `}
`
